module.exports = __webpack_public_path__ + "img/setup-image.2d5d3c43.svg";